/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type MinimalClient = {
    id: number;
    firstName: string;
    lastName: string;
    gender: MinimalClient.gender;
    status: MinimalClient.status;
    email: string | null;
    phoneNumber: string | null;
    deleted: boolean;
};
export namespace MinimalClient {
    export enum gender {
        MALE = 'male',
        FEMALE = 'female',
        DIVERSE = 'diverse',
        NOT_SET = 'not_set',
        DELETED = 'deleted',
    }
    export enum status {
        NEW = 'new',
        CLIENT = 'client',
        WITHOUT_ACCOUNT = 'without-account',
        WITH_ACCOUNT = 'with-account',
        ACTIVE = 'active',
        INACTIVE = 'inactive',
    }
}

